/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { Switch, Route } from 'react-router-dom';

import useReduxState from 'src/shared/app/base/hook/useReduxState';
import useRouteConfig from 'src/shared/app/base/route/hook/useRouteConfig';
import useRoutes from 'src/shared/app/base/route/hook/useRoutes';
import { getRoutes } from 'src/shared/app/base/route/registry/routeRegistry';
import {
  getRouteTemplate,
  getRouteRedirect,
} from 'src/shared/app/base/route/util/routeUtils';

const TemplateSwitch = (): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const state = useReduxState();
  const config = useRouteConfig();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <Switch>
      {getRoutes().map((route) => {
        // @TODO - really bad use of hook
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const path = useRoutes(route);

        return (
          <Route
            path={path}
            exact
            render={() => {
              if (getRouteRedirect(route, state, config)) {
                // `RedirectSwitch` is instanciated before `TemplateSwitch`, but the
                // latter can somehow still be rendered before the redirection
                // happens. To prevent any exception to be thrown, we render null
                // if we know there's a redirection
                return null;
              }

              return React.createElement(
                getRouteTemplate(route, state, config),
              );
            }}
            // Use the same key to prevent re-renders when routes share the
            // same template
            key={1}
          />
        );
      })}
    </Switch>
  );
};

export default compose(React.memo)(TemplateSwitch);
